import { __extends } from "tslib";
import { UpdateAdmChannelRequest, UpdateAdmChannelResponse } from "../models/models_1";
import { deserializeAws_restJson1UpdateAdmChannelCommand, serializeAws_restJson1UpdateAdmChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Enables the ADM channel for an application or updates the status and settings of the ADM channel for an application.</p>
 */
var UpdateAdmChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateAdmChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateAdmChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    UpdateAdmChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "UpdateAdmChannelCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: UpdateAdmChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateAdmChannelResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateAdmChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateAdmChannelCommand(input, context);
    };
    UpdateAdmChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateAdmChannelCommand(output, context);
    };
    return UpdateAdmChannelCommand;
}($Command));
export { UpdateAdmChannelCommand };
//# sourceMappingURL=UpdateAdmChannelCommand.js.map